/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Vector3 } from 'three';
/**
 * common vertex shader for all point shaders
 */
export class DistanceFieldShader {
    static createVertexShader(billboard) {
        return `
        uniform vec3 mcolor;
        uniform bool billboard;
        uniform float opacity;
        varying vec3 vColor;
        varying vec2 vUv;
        varying float vOpacity;

        void main()
        {
            vUv = uv;
            vColor = mcolor;
            vec4 mvPosition;
            vOpacity = opacity;
    `
            + (billboard ? `
              float sx = length(modelViewMatrix[0].xyz);
              float sy = length(modelViewMatrix[1].xyz);

              mvPosition =  modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
              mvPosition.xy += position.xy * vec2(sx, sy);
    ` : `
              mvPosition =  modelViewMatrix * vec4( position, 1.0 );
    `) + `
            gl_Position = projectionMatrix * mvPosition;
        } `;
    }
    /**
     * shader to draw SDF Shapes
     */
    static createSDFShader() {
        return `
            uniform sampler2D map;
            varying vec2 vUv;
            varying vec3 vColor;
            const float smoothing = 1.0/16.0;
            void main()
            {
                float dist = texture2D(map, gl_PointCoord).r;
                float alpha = smoothstep(0.5 - smoothing, 0.5 + smoothing, dist);
                gl_FragColor = vec4(vColor, alpha);
            }`;
    }
    /**
     * shader to draw SDF Shapes
     */
    static createMSDFShader() {
        return `
            #extension GL_OES_standard_derivatives : enable
            uniform sampler2D map;
            varying vec2 vUv;
            varying vec3 vColor;
            varying float vOpacity;

            float median(float r, float g, float b) {
            return max(min(r, g), min(max(r, g), b));
            }

            void main()
            {
            vec3 p = texture2D(map, vUv).rgb;
            float sigDist = median(p.r, p.g, p.b) - 0.5;
            float alpha = clamp(sigDist/fwidth(sigDist) + 0.5, 0.0, 1.0);
            if ( alpha == 0.0) discard;
            gl_FragColor = vec4(vColor, alpha * vOpacity);
            }
          `;
    }
}
DistanceFieldShader.uniforms = {
    mcolor: { value: new Vector3(0, 0, 0) },
    map: { value: null },
    opacity: { value: 1.0 },
};
//# sourceMappingURL=DistanceFieldShader.js.map